import http from '@/plugins/axios/axios';

export default class LoginIKAcessoService {

    constructor() {
        this.baseUrl = process.env.VUE_APP_BASE_URL_ADMIN_IKACESSO;      
    }

    autenticar(usuario) {
        return http.request({
            method: 'post',
            withCredentials: true,
            url: this.baseUrl + '/api/login/v1/admin',
            data: usuario
        });
    }
    
}